import { profile } from '../../../model/profile';

export interface IState {
    isFetching: boolean;
    profile: profile;
    error: any;
}

let persistedAuthState: any = null;
try {
    persistedAuthState = JSON.parse(localStorage.getItem('persistedAuthState'));
} catch (ex) {
    console.error('Exception while parsing persistedAuthState', ex);
}

export const DefaultState = (): IState =>
    persistedAuthState ? persistedAuthState :
        ({
            isFetching: false,
            profile: {
                sub: '',
                nickname: '',
                name: '',
                picture: '',
                updated_at: '',
                email: '',
                email_verified: false
            },
            error: null
        })